import { faBookmark, faComment } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-regular-svg-icons';
import { faFacebook, faTwitter, faWhatsapp, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { Helmet } from 'react-helmet-async';

const ConferenceTransport = () => {
    return (
        <>
            <Helmet>
                <title>How to Organize Transport for Large Conferences & Events</title>
                <meta
                    name="description"
                    content="Learn how to plan efficient transport for large conferences and events using rental vans, smart scheduling, and professional coordination."
                />
            </Helmet>
            <div className="bg-[#fff] w-full flex flex-col">
                <section
                    className="hero--container relative flex flex-col justify-center w-full bg-no-repeat bg-cover bg-center pt-[65px] mt-[140px] md:h-[60vh]"
                    style={{ backgroundImage: `url('../images/conference-transport.jpg')` }}
                >
                    <div className="absolute inset-0 bg-black bg-opacity-50 z-0"></div>
                    <div className="relative z-10">
                        <h1 className="text-center text-white text-2xl md:text-5xl font-bold uppercase leading-9">
                            How to Organize Transport for Large Conferences and Events
                        </h1>

                        <div className="flex justify-center items-center gap-4 mt-10 md:text-sm text-xs mb-2">
                            <div className="flex items-center gap-2 text-white">
                                <FontAwesomeIcon icon={faClock} className="w-4" />
                                <p className="blog-publish-date">01/06/2026</p>
                            </div>

                            <div className="flex items-center gap-2 text-white">
                                <FontAwesomeIcon icon={faComment} className="w-4" />
                                <p className="blog-publish-date">10 Comments</p>
                            </div>

                            <div className="flex items-center gap-2 text-white">
                                <FontAwesomeIcon icon={faBookmark} />
                                <p className="blog-publish-date">2800 Views</p>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="body--container w-full px-4 py-8 md:py-10 md:px-12 lg:px-16 xl:px-20 2xl:px-24">
                    <div className="mx-auto max-w-screen-md">
                        <p className="pb-4 text-justify leading-7">
                            Planning transport for a large conference or event can feel overwhelming, but with the right approach, it can be smooth and efficient. Whether you’re handling a corporate seminar, an industry trade show, or a multi-day summit, organizing transportation is key to guest satisfaction and overall event success.
                        </p>

                        <p className="pb-4 text-justify leading-7">
                            The first step is to assess the number of attendees and identify where they’ll be coming from—hotels, the airport, or local offices. Knowing this helps you schedule pickups and drop-offs at convenient times and locations.
                        </p>

                        <p className="pb-4 text-justify leading-7">
                            Next, choose the right type of vehicle. Passenger vans are ideal for medium-sized groups and are more economical than renting multiple cars. They’re spacious, comfortable, and easier to manage when coordinating large numbers. If you’re transporting equipment or event materials, consider booking a cargo van in addition.
                        </p>

                        <p className="pb-4 text-justify leading-7">
                            Partnering with a professional rental company like JJ Van Rental ensures access to a modern, well-maintained fleet. We offer both short-term and long-term contracts with flexible scheduling. You can even request delivery of your van directly to the airport, hotel, or venue for an added convenience.
                        </p>

                        <p className="pb-4 text-justify leading-7">
                            On the day of the event, assign a transportation coordinator to track van movement, communicate with drivers, and troubleshoot any delays. GPS-enabled vans and mobile apps can be a major help here, allowing real-time updates for all attendees.
                        </p>

                        <p className="pb-4 text-justify leading-7">
                            In conclusion, organizing transport for large conferences and events doesn’t have to be a hassle. With careful planning, the right rental vans, and a trusted provider, you can create a reliable and smooth experience that enhances your event’s professionalism.
                        </p>
                    </div>
                </section>

                <section className="mb-8">
                    <div className="max-w-screen-md mx-auto rounded-md px-4 py-3 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                        {/* Tags Section */}
                        <div className="flex flex-wrap gap-2">
                            <p className="bg-gray-200 text-gray-600 px-2 py-1 rounded-md">Conference</p>
                            <p className="bg-gray-200 text-gray-600 px-2 py-1 rounded-md">Event Transport</p>
                            <p className="bg-gray-200 text-gray-600 px-2 py-1 rounded-md">Van Rental</p>
                        </div>

                        {/* Social Buttons Section */}
                        <div className="flex flex-wrap items-center gap-3">
                            <div className="flex items-center bg-[#42599E] px-3 py-2 rounded-lg text-white text-sm">
                                <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1">
                                    <FontAwesomeIcon icon={faFacebook} /> Share
                                </a>
                            </div>
                            <div className="flex items-center bg-[#55ACEE] px-3 py-2 rounded-lg text-white text-sm">
                                <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1">
                                    <FontAwesomeIcon icon={faTwitter} /> Tweet
                                </a>
                            </div>
                            <div className="flex items-center bg-[#34AF23] px-3 py-2 rounded-lg text-white text-sm">
                                <a href="https://www.whatsapp.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1">
                                    <FontAwesomeIcon icon={faWhatsapp} /> WhatsApp
                                </a>
                            </div>
                            <div className="flex items-center bg-[#0798CF] px-3 py-2 rounded-lg text-white text-sm">
                                <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1">
                                    <FontAwesomeIcon icon={faLinkedin} /> LinkedIn
                                </a>
                            </div>
                        </div>
                    </div>

                </section>
            </div>
        </>

    );
};

export default ConferenceTransport;